export { QueryStringMatch } from './generated/QueryStringMatch.js';